export var compKey = 'selector-button';
//# sourceMappingURL=key.js.map